export const CONTAINER_SIZE = 'lg'; // Reference : createBreakpoints.Breakpoint